import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel, IonRow, IonCol, IonFooter, IonRange,
} from '@ionic/react';
import {actionToGetRfpAssignmentDataByFilter} from "../apiHelpers/CommonAction";
import {_getExpiryDateFromRange, _getIndianStates} from "../apiHelpers/CommonHelper";
import useStore from "../zustand/useStore";

const retainershipTypes = ['Retainership', 'Assignment'];
export default function AssignmentsFilterSheetModal({ isOpen,myPostsData, onDidDismiss,filterTypeSelection,setFilterTypeSelection }) {
    const {
        selectedRetainership,
        selectedExpiryDate,
        selectedPrice,
        selectedAssignmentLocation,
        setSelectedRetainership,
        setSelectedExpiryDate,
        setSelectedPrice,
        setSelectedAssignmentLocation,
        resetAssignmentFilters,
    } = useStore();

    const applyFilters = async (
        retainership,
        locations,
        minPrice,
        daysLeft
    ) => {
        const payload = {};
        if (retainership) payload.retainership = retainership;
        if (locations.length > 0) payload.location = locations;
        if (daysLeft) payload.expiry_date = _getExpiryDateFromRange(daysLeft);
        if (minPrice > 0) payload.price_max = minPrice;
        payload.me_mode = !!myPostsData;

        await actionToGetRfpAssignmentDataByFilter(true, payload);
    };

    const handleAssignmentTypeCheckboxChange = (value) => {
        let assignmentType;
        if (selectedRetainership === value) {
            assignmentType = ''
        } else {
            assignmentType = value;
        }
        setSelectedRetainership(assignmentType);
        applyFilters(
            assignmentType,
            selectedAssignmentLocation,
            selectedPrice,
            selectedExpiryDate
        );
    };

    const handleLocationChange = async (value) => {
        let location;
        if (selectedAssignmentLocation.includes(value)) {
            location = selectedAssignmentLocation.filter((v) => v !== value);
        } else {
            location = [...selectedAssignmentLocation, value];
        }

        setSelectedAssignmentLocation(location);
        applyFilters(
            selectedRetainership,
            location,
            selectedPrice,
            selectedExpiryDate
        );
    };

    const handlePriceChange = (e) => {
        const val = Number(e.detail.value);
        setSelectedPrice(val);
        applyFilters(
            selectedRetainership,
            selectedAssignmentLocation,
            val,
            selectedExpiryDate
        );
    };

    const handleDaysLeftChange = (value) => {
        let expiredDate;
        if (selectedExpiryDate === value) {
            expiredDate = ''
        } else {
            expiredDate = value;
        }
        setSelectedExpiryDate(expiredDate);
        applyFilters(
            selectedRetainership,
            selectedAssignmentLocation,
            selectedPrice,
            expiredDate
        );
    };

    const handleClearFilters = async () => {
        resetAssignmentFilters();
        onDidDismiss();
        await actionToGetRfpAssignmentDataByFilter(true,{me_mode:!!myPostsData});
    };

    const showApplyButton =
        selectedRetainership ||
        selectedExpiryDate ||
        selectedAssignmentLocation.length > 0 ||
        selectedPrice > 0


    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="filter_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle className="filter_sheet_header_text">Filter RFPs</IonTitle>
                    {(showApplyButton) && (
                        <IonButtons slot="end">
                            <div onClick={handleClearFilters} className="filter_sheet_clear_all_btn">Clear all</div>
                        </IonButtons>
                    )}
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <div className="filter-content">
                    <div className="filter-menu">
                        <IonList>
                            {[
                                "Assignment Type",
                                "Location",
                                "Maximum Price",
                                "Days Left"
                            ].map((item, i) => (
                                <IonItem className={`filter_item_sheet_panel ${filterTypeSelection === item ? 'active' : ''}`} onClick={()=>setFilterTypeSelection(item)} key={i} button lines="none">
                                    {item}
                                </IonItem>
                            ))}
                        </IonList>
                    </div>

                    <div className="filter-options">
                        {(filterTypeSelection === 'Assignment Type') &&
                            <IonList>
                                {retainershipTypes.map((type) => (
                                    <IonItem lines="none" className="filter_item_sheet_panel" key={type}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedRetainership === type}
                                            onIonChange={() =>
                                                handleAssignmentTypeCheckboxChange(type)
                                            }
                                        />
                                        <IonLabel>{type}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }
                        {(filterTypeSelection === 'Location') &&
                            <IonList>
                                {_getIndianStates.map((location) => (
                                    <IonItem key={location} className="filter_item_sheet_panel"  lines="none">
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedAssignmentLocation.includes(location)}
                                            onIonChange={() => handleLocationChange(location)}
                                        />
                                        <IonLabel>{location}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }
                        {(filterTypeSelection === 'Maximum Price') &&
                            <IonList className={"in_mobile_filter_list"}>
                                <IonRange min={10000} max={100000} step={5000} pin snaps value={selectedPrice}
                                          onIonChange={handlePriceChange}/>
                                <div className="range-labels">
                                    <span>₹10,000</span>
                                    <span>₹1,00,000</span>
                                </div>
                            </IonList>
                        }
                        {(filterTypeSelection === 'Days Left') &&
                            <IonList>
                                {['1-7', '8-15', '16+'].map((range) => (
                                    <IonItem lines="none" key={range}>
                                        <IonCheckbox
                                            slot="start"
                                            checked={selectedExpiryDate === range}
                                            onIonChange={() => handleDaysLeftChange(range)}
                                        />
                                        <IonLabel>{range} Days</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        }
                    </div>
                </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={onDidDismiss}>Close</IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
